export const en = {
    action_submit: 'Revoke',
    revoke_from: 'From employees',
    title: 'Revoke coordinator role',
};
